import ArmoryPreloader from '~/core/AppInit/ArmoryPreloader';
import AuctionPreloader from '~/core/AppInit/AuctionPreloader';
import store from '~/Store';
import { finishLoadingResources } from '~/Actions/ActionApp';
import PremiumShopPreloader from '~/core/AppInit/PremiumShopPreloader';
import FeaturesPreloader from '~/core/AppInit/FeaturesPreloader';
import SeaBattlePreloader from '~/core/AppInit/SeaBattlePreloader';
import DockyardPreloader from '~/core/AppInit/DockyardPreloader';
import TradeInPreloader from '~/core/AppInit/TradeInPreloader';

async function AppInit(): Promise<void> {
    await new ArmoryPreloader().load();

    const promises = [
        new PremiumShopPreloader().load(),
        new AuctionPreloader().load(),
        new FeaturesPreloader().load(),
        new DockyardPreloader().load(),
        new SeaBattlePreloader().load(),
        new TradeInPreloader().load(),
    ];

    await Promise.all(promises);

    store.dispatch(finishLoadingResources());
}

export default AppInit;
